import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const searchEmployeeByEmail = createAsyncThunk(
  'manageMomentUser/searchEmployeeByEmail',
  async ({ email }, { signal, rejectWithValue }) => {
    try {
      const res = await axios.get(`${API_URL}/api/employee/search`, { signal, params: { email } });
      const json = res.data || {};
      if (!json.success) throw new Error(json?.message || 'Employee not found');
      return json.employee;
    } catch (e) {
      if (e?.code === 'ERR_CANCELED' || e?.name === 'CanceledError') throw e;
      console.error('manageMomentUser/searchEmployeeByEmail failed', e);
      return rejectWithValue(e?.message || 'Employee not found');
    }
  }
);

export const fetchEmployeeAccess = createAsyncThunk(
  'manageMomentUser/fetchEmployeeAccess',
  async ({ employeeId }, { signal, rejectWithValue }) => {
    try {
      const res = await axios.get(`${API_URL}/api/settings/access/get`, {
        signal,
        params: { employeeId },
      });
      return res.data;
    } catch (e) {
      if (e?.code === 'ERR_CANCELED' || e?.name === 'CanceledError') throw e;
      console.error('manageMomentUser/fetchEmployeeAccess failed', e);
      return rejectWithValue(e?.message || 'Failed to load access');
    }
  }
);

export const updateEmployeeAccess = createAsyncThunk(
  'manageMomentUser/updateEmployeeAccess',
  async ({ employeeId, allowedPages, permissionLevel }, { signal, rejectWithValue }) => {
    try {
      const res = await axios.post(
        `${API_URL}/api/settings/access/update`,
        { employeeId, allowed_pages: allowedPages, permission_level: permissionLevel },
        { signal, headers: { 'Content-Type': 'application/json' } }
      );
      return res.data;
    } catch (e) {
      if (e?.code === 'ERR_CANCELED' || e?.name === 'CanceledError') throw e;
      console.error('manageMomentUser/updateEmployeeAccess failed', e);
      return rejectWithValue(e?.response?.data?.message || e?.message || 'Failed to save');
    }
  }
);

export const offboardEmployee = createAsyncThunk(
  'manageMomentUser/offboardEmployee',
  async ({ employeeId, email, leaverDate }, { signal, rejectWithValue }) => {
    try {
      const res = await axios.post(
        `${API_URL}/api/employee/offboard`,
        { employeeId, email, leaverDate },
        { signal, headers: { 'Content-Type': 'application/json' } }
      );
      const json = res.data || {};
      if (json.success === false) throw new Error(json?.message || 'Offboard failed');
      return json;
    } catch (e) {
      if (e?.code === 'ERR_CANCELED' || e?.name === 'CanceledError') throw e;
      console.error('manageMomentUser/offboardEmployee failed', e);
      return rejectWithValue(e?.message || 'Offboard failed');
    }
  }
);

const slice = createSlice({
  name: 'manageMomentUser',
  initialState: { error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      (action) => action.type.startsWith('manageMomentUser/') && action.type.endsWith('/rejected'),
      (state, action) => {
        if (action?.meta?.aborted) return;
        state.error = action.payload || action.error?.message || null;
      }
    );
  },
});

export default slice.reducer;


